import apiClient, { getErrorMessage } from './api.service';
import { API_ENDPOINTS } from '../config/api';

export interface BookingStatus {
  bookingEnabled: boolean;
  bookingClosedMessage: string;
  pricePerAcademicYear?: number;
}

class ConfigService {
  /**
   * Public booking availability. Readable without authentication so the
   * home-page banner and auth modal can display it to logged-out visitors.
   */
  async getBookingStatus(): Promise<BookingStatus> {
    try {
      const response = await apiClient.get<{
        status: string;
        data: { config: BookingStatus };
      }>(API_ENDPOINTS.CONFIG.BOOKING_STATUS);

      return response.data.data.config;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  }
}

const configService = new ConfigService();
export default configService;
